
/**
 * @file axios请求封装
 * @author shecaihua(shecaihua@baidu.com)
 */
import {values} from 'lodash';
import {toast} from 'acud';
import axios from 'axios';
const instance = axios.create({
    timeout: 30000,
    // baseURL: 'http://yapi.baidu-int.com/mock/4034/'
    headers: {
        'x-requested-with': 'XMLHttpRequest',
    },
});

export function getErrorMessage(error) {
    if (error.global) {
        return error.global;
    }
    else if (error.field) {
        // 显示错误的信息
        return values(error.field).join(', ');
    }
    else if (error.code && error.message && error.message.field) {
        // {
        //   success: false,
        //   requestId: string,
        //   code: string,
        //   message: {
        //     field: {
        //       foo: bar
        //       ...
        //     }
        //  }
        // }
        return values(error.message.field).join(', ');
    }
    if (error.field && error.field.verifyCode) {
        return error.field.verifyCode;
    }
    return String(error);
}

// Add a response interceptor
instance.interceptors.response.use((response: any) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const data = response.data;
    // data.success 是字符串 'false'
    if (data.success === true) {
        // 接口有两种 没有分页取 result 有分页就是page
        return data.result || data.page;
    }
    else {
        if (data.message && data.message.redirect) {
            location.href = data.message.redirect;
            return;
        }
        const error = getErrorMessage(data.message);
        toast.error({message: error});
    }
    return Promise.reject(data);
}, error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.data?.message) {
        toast.error({message: error?.response?.data?.message});
    }
    return Promise.reject(error);
});

export default instance;
